export default "__VITE_ASSET__3c2d9b2b__"